import React, { useEffect, useState } from 'react';
import {Skeleton, Typography, Grid, Card, CardContent, Stack} from '@mui/material';
import {Button} from '@mui/joy';
import chroma from "chroma-js";

const RegionTrackingCountsComponent = ({regionsContainerRef, regions, isLoadingGetVerificationCount, onChangeRegion}) => {

    const [currentRegion, setCurrentRegion] = useState(null);

    useEffect(() => {
        const highest = regions.reduce((max, item) => 
            parseFloat(item.percent) > parseFloat(max.percent) ? item : max
        );
        setCurrentRegion(highest.percent == 0 ? {} : highest)
    }, [JSON.stringify(regions)])

    useEffect(() => {
        if (currentRegion) {
            onChangeRegion(currentRegion)
        }
    }, [JSON.stringify(currentRegion)])

    const handleClickRegion = (value) => {
        setCurrentRegion(value);
    };

    return(
        <>
            <Card ref={regionsContainerRef} variant="outlined">
                <CardContent>
                    <Grid container spacing={2}>
                        {
                            (isLoadingGetVerificationCount) ? 
                                [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16].map((item) => (
                                    <Grid item xs={6} sm={6} md={6} lg={4} xl={4}>
                                        <Skeleton variant="square" sx={{backgroundColor: "#d8d8fdbd", borderRadius: "6px"}} height="60.2px" />
                                    </Grid>
                                ))
                            :
                                regions.map((item) => (
                                    <Grid item xs={6} sm={6} md={6} lg={4} xl={4}>
                                        <Button
                                            onClick={() => handleClickRegion(item)}
                                            sx={{
                                                width: '100%',
                                                bgcolor: item.color,
                                                border: currentRegion?.region == item.region ? `2px solid ${chroma(item.color).darken().hex()}` : null,
                                                color: '#fff',
                                                '&:hover': {
                                                    bgcolor: chroma(item.color).darken().hex(),
                                                },
                                                transition: currentRegion?.region == item.region ? 'transform 0.2s ease-in-out' : null,
                                                transform: currentRegion?.region == item.region ? 'scale(1.1)' : null,
                                            }}
                                        >
                                            <Stack direction={"column"}>
                                                <Typography>{item.percent} %</Typography>
                                                <Typography>{item.region}</Typography>
                                            </Stack>
                                        </Button>
                                    </Grid>
                                ))
                        }
                    </Grid>
                </CardContent>
            </Card>
        </>
    )
}

export default RegionTrackingCountsComponent